// <!--
//   -
//   - ███╗░░██╗░█████╗░████████╗░█████╗░███████╗░█████╗░██╗░░██╗░██████╗
//   - ████╗░██║██╔══██╗╚══██╔══╝██╔══██╗██╔════╝██╔══██╗██║░██╔╝██╔════╝
//   - ██╔██╗██║██║░░██║░░░██║░░░███████║█████╗░░██║░░██║█████═╝░╚█████╗░
//   - ██║╚████║██║░░██║░░░██║░░░██╔══██║██╔══╝░░██║░░██║██╔═██╗░░╚═══██╗
//   - ██║░╚███║╚█████╔╝░░░██║░░░██║░░██║██║░░░░░╚█████╔╝██║░╚██╗██████╔╝
//   - ╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░░░░░╚════╝░╚═╝░░╚═╝╚═════╝░
//   -
//   - copyright: https://notafoks.me
//   - year: 2020-2022
//   -
//   - Данный код является интеллектуальной собственностью ВШЭ,
//   - однако был разработан программистом Яков Панов (https://notafoks.me)
//   -
//   -->
import { FC } from 'react';

type Props  = {
  fill: string
}

export const AupArrowSvg: FC<Props> = ({ fill }) => {
  return (
      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 5.36851L1.69486 0.917601C1.47871 0.69413 1.12826 0.694133 0.912111 0.917606C0.695961 1.14108 0.695963 1.5034 0.912115 1.72687L5.60863 6.5824C5.82478 6.80587 6.17522 6.80587 6.39137 6.5824L11.0879 1.72687C11.304 1.5034 11.304 1.14108 11.0879 0.917606C10.8717 0.694133 10.5213 0.69413 10.3051 0.917601L6 5.36851Z" fill="#909090"/>
      </svg>
  )
}
// <!--
//   -
//   - ███╗░░██╗░█████╗░████████╗░█████╗░███████╗░█████╗░██╗░░██╗░██████╗
//   - ████╗░██║██╔══██╗╚══██╔══╝██╔══██╗██╔════╝██╔══██╗██║░██╔╝██╔════╝
//   - ██╔██╗██║██║░░██║░░░██║░░░███████║█████╗░░██║░░██║█████═╝░╚█████╗░
//   - ██║╚████║██║░░██║░░░██║░░░██╔══██║██╔══╝░░██║░░██║██╔═██╗░░╚═══██╗
//   - ██║░╚███║╚█████╔╝░░░██║░░░██║░░██║██║░░░░░╚█████╔╝██║░╚██╗██████╔╝
//   - ╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░░╚═╝╚═╝░░░░░░╚════╝░╚═╝░░╚═╝╚═════╝░
//   -
//   - copyright: https://notafoks.me
//   - year: 2020-2022
//   -
//   - Данный код является интеллектуальной собственностью ВШЭ,
//   - однако был разработан программистом Яков Панов (https://notafoks.me)
//   -
//   -->
import { FC } from 'react';

type Props  = {
  fill: string
}

export const AupArrowSvg: FC<Props> = ({ fill }) => {
  return (
      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 5.36851L1.69486 0.917601C1.47871 0.69413 1.12826 0.694133 0.912111 0.917606C0.695961 1.14108 0.695963 1.5034 0.912115 1.72687L5.60863 6.5824C5.82478 6.80587 6.17522 6.80587 6.39137 6.5824L11.0879 1.72687C11.304 1.5034 11.304 1.14108 11.0879 0.917606C10.8717 0.694133 10.5213 0.69413 10.3051 0.917601L6 5.36851Z" fill="#909090"/>
      </svg>
  )
}
